__turbopack_context__.v({
  "address": "Footer-module-scss-module__DkSkqG__address",
  "bottom": "Footer-module-scss-module__DkSkqG__bottom",
  "contact": "Footer-module-scss-module__DkSkqG__contact",
  "cvr": "Footer-module-scss-module__DkSkqG__cvr",
  "footer": "Footer-module-scss-module__DkSkqG__footer",
  "inner": "Footer-module-scss-module__DkSkqG__inner",
  "links": "Footer-module-scss-module__DkSkqG__links",
  "logo": "Footer-module-scss-module__DkSkqG__logo",
  "smiley": "Footer-module-scss-module__DkSkqG__smiley",
});
